module.exports = __webpack_public_path__ + "static/media/voiture_02_full.f9bb7c82.jpg";